<template>
  <div v-rect-loading="loading" class="hidden-potential-page">
    <div class="hidden-potential-container">
      <ReferralCard
        v-for="(potential) in potentialList"
        class="hidden-potential-list"
        :key="potential.potential_id"
        :referralInfo="potential"
      >
        <template #status>
          <el-switch
            v-model="potential.switch"
            class="status"
            :active-text="$t(`${i18nPrefix}.label.switchActive`)"
            :inactive-text="$t(`${i18nPrefix}.label.switchInactive`)"
            :width="60"
            @change="handelShow(potential)"
          >
          </el-switch>
        </template>
      </ReferralCard>
    </div>
    <div v-if="!potentialList || potentialList.length < 1" class="tip">{{ $t(`${i18nPrefix}.message.leadNoData`) }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import ReferralCard from './referralCard.vue'
import { addI18nProperty } from '@/i18n'

export default {
  props: {

  },
  components: {
    ReferralCard
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leads',
      potentialList: [],
      loading: false,
      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        totalPage: 1
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.getPotentialCandidateData(true)
  },
  methods: {
    ...mapActions('personal', ['getMyHiddenPotentialCandidate', 'updateMyPotentialCandidateAttitude']),
    async getPotentialCandidateData (resetPage) {
      if (this.loading) {
        return
      }
      const page = resetPage ? 1 : this.pageInfo.currentPage + 1
      if (page > this.pageInfo.totalPage) {
        return
      }

      this.loading = true
      try {
        const params = {
          page: page,
          page_size: this.pageInfo.pageSize,
          company_id: this.companyId
        }
        const resp = await this.getMyHiddenPotentialCandidate(params)
        if (resp) {
          this.pageInfo.totalPage = resp.total_pages
          this.pageInfo.currentPage = resp.page_num
          const results = this.formatResult(resp.results)
          this.potentialList = _.concat(this.potentialList, results)
        }
      } finally {
        this.loading = false
      }
    },
    formatResult (results) {
      _.forEach(results, result => {
        this.$set(result, 'switch', false)
        addI18nProperty(result.job, 'jobTitle', 'cn_title', 'title')
        _.forEach(result.referral_chain, item => {
          addI18nProperty(item.city, 'cityName', 'cn_name', 'name')
        })
      })
      return results
    },
    async handelShow (potential) {
      if (this.loading) {
        return
      }
      this.loading = true
      try {
        const resp = await this.updateMyPotentialCandidateAttitude({
          data_type: 'hide',
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize,
          potential_id: potential.potential_id,
          company_id: this.companyId,
          action: '3'
        })
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
          this.pageInfo.totalPage = resp.total_pages
          this.pageInfo.currentPage = resp.page_num
          this.potentialList = this.formatResult(resp.results)
        }
      } finally {
        this.loading = false
      }
    },
    handleScroll () {
      this.getPotentialCandidateData()
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden-potential-page {
  .hidden-potential-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 235px); // 设置每个网格宽度为235px
    row-gap: 24px;
    column-gap: 18px;
    align-items: center;
    justify-content: space-between;

    .hidden-potential-list {
      ::v-deep .referral-content {
        position: relative;
      }

      .status {
        height: 22px;
        position: absolute;
        top: 4px;
        right: 4px;
        text-align: center;
        font-size: 12px;
        line-height: 24px;
        color: #fff;

        &.el-switch.is-checked {
          ::v-deep {
            .el-switch__core {
              border-color: #0096cc;
              background-color: #0096cc;
            }
          }
        }

        ::v-deep {
          .el-switch__core {
            height: 22px;
            border-color: #c0c4cc;
            background-color: #c0c4cc;

            &:after {
              top: 4px;
              width: 12px;
              height: 12px;
            }
          }

          .el-switch__label {
            display: none;
            position: absolute;
            line-height: 22px;
            height: 22px;
            margin: 0;
            z-index: 1;

            span {
              font-size: 12px;
            }
          }

          .el-switch__label--left {
            width: 60px;
            padding-left: 10px;
            text-align: center;
            color: #fff;
          }

          .el-switch__label--right {
            width: 60px;
            padding-right: 18px;
            color: #fff;
          }

          .el-switch__label.is-active {
            display: inline-block;
          }
        }
      }
    }
  }

  .tip {
    text-align: center;
    padding-top: 20px;
  }
}
</style>
